import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import { fetchCountries } from 'redux/users/actions';

import { Dropdown } from 'semantic-ui-react';

import Button from 'components/elements/buttons/Button';

import './ConnectStripeStep2.css';


function ConnectStripeStep2(props) {
  const {
    fetchCountries,
    setActiveStep,
    countries,
    currencies,
    setStripeCountry,
    setStripeCurrency,
  } = props;

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    fetchCountries('stripe');
    return () => {
      fetchCountries();
    };
  }, []);

  const currenciesOptions = currencies ?
    currencies.map(
      currency => (
        {
          key: currency.currency_code,
          text: currency.currency_code,
          value: currency.id,
          symbol: currency.currency_symbol,
        }
      ),
    ) : [];

  const countriesOptions = countries && countries.length > 0 ?
    countries.map(i => ({
      key: `country_id_${i.id}`,
      text: i.name,
      value: i.id,
    })) : [];

  return (
    <div className="connect-stripe-step2__component">
      <div className="header">
        {t("Select your country and the currency of your Stripe account")}
      </div>

      <div className="dropdowns-wrapper">
        <Dropdown
          fluid
          search
          selection
          placeholder={t("Select your country")}
          value={selectedCountry}
          options={countriesOptions}
          onChange={(_e, data) => {
            setSelectedCountry(data.value);
            setStripeCountry(data.value);
          }}
        />

        <Dropdown
          fluid
          search
          selection
          placeholder={t("Select your currency")}
          value={selectedCurrency}
          options={currenciesOptions}
          onChange={(_e, data) => {
            setSelectedCurrency(data.value);
            setStripeCurrency(data.value);
          }}
        />
      </div>

      <div className="buttons-block">
        <Button
          small
          borderedBlue
          onClick={() => setActiveStep('stripe-step-1')}
        >
          &#10094;&nbsp;&nbsp;{t("Back")}
        </Button>
        <Button
          small
          onClick={() => setActiveStep('stripe-step-3')}
          disabled={!selectedCountry || !selectedCurrency}
        >
          {t("Next")}
        </Button>
      </div>
    </div>
  );
}

ConnectStripeStep2.propTypes = {
  fetchCountries: PropTypes.func.isRequired,
  setStripeCountry: PropTypes.func.isRequired,
  setStripeCurrency: PropTypes.func.isRequired,
  setActiveStep: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape),
  currencies: PropTypes.arrayOf(PropTypes.shape),
};

ConnectStripeStep2.defaultProps = {
  setActiveStep: PropTypes.func.isRequired,
  countries: null,
  currencies: null,
};

const mapStateToProps = state => (
  {
    countries: state.usersReducer.countries,
    currencies: state.commonReducer.currencies,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchCountries,
  },
)(ConnectStripeStep2);
